import script from "./allCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./allCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./allCampaigns.vue?vue&type=style&index=0&id=7c3f4d50&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3f4d50"]])

export default __exports__